import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Permission } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from './api.service.abstract';

@Injectable({ providedIn: 'root' })
export class PermissionService extends ApiService<Permission> {
  constructor(@Inject(APP_CONFIG) environment: any, private http: HttpClient) {
    super(environment, http, '/user/api/permissions');
    if (environment.name === 'localDev') {
      this.url = 'http://localhost:8095';
    }
  }

  getAllPermissions(): Observable<HttpResponse<Permission[]>> {
    return this.http.get<Permission[]>(`${this.url}/${this.endpoint}`, {
      observe: 'response',
    });
  }
}
